import { GET_USUARIO } from "../actions/types";

const INITIAL_STATE = {};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_USUARIO:
      console.log("R:", action.payload.Result);
      return { ...action.payload.Result };
    default:
      return state;
  }
};
